/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Dropdown, Tag } from 'antd'
import { Edit3, Eye, Handshake, Shield, ShieldOff, Trash } from 'lucide-react';
import { isEmpty } from '../../utils/helpers';
import { MoreOutlined } from '@ant-design/icons';
import { DataGrid } from '@mui/x-data-grid';
import { CustomNoRowsOverlay } from './common';


function DataGridTable({ tableStruture = [], tableActions = [], loading = false, setLoading = () => { }, totalCount, data, pagination = false, handleChangePagination }) {
    const [customColumns, setCustomColumns] = useState([]);
    const [isTableLoading, setTableLoading] = useState(loading);

    useEffect(() => {
        setTableLoading(loading);
    }, [loading])

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
            setTableLoading(false);
        }, 600);
    }, [data])

    useEffect(() => {
        const customizeColumns = tableStruture?.map((item, itemIndex) => {
            const key = item?.key;
            const emptyElement = <div className='cursor-no-drop'>
                <span className="text-[13px]">-</span>
            </div>

            if (key === "actions") return {
                ...item, title: (tableActions.length !== 0 ? item?.title : ""),
                renderCell: (val) => {
                    const value = val?.row;
                    const items = (tableActions?.map((actionItem, actionIndex) => {
                        const handleClick = actionItem?.handleOnClick
                        if (actionItem?.isView) return {
                            key: actionIndex + 1,
                            onClick: () => handleClick(value),
                            label: <span className='!text-sm text-blue-600'>View</span>,
                            icon: <Eye className='icon text-blue-600' />
                        }
                        if (actionItem?.isAssign) return {
                            key: actionIndex + 1,
                            onClick: () => handleClick(value),
                            label: <span className='!text-sm'>Assign</span>,
                            icon: <Handshake className='icon' />
                        }
                        if (actionItem?.isMFA) return {
                            key: actionIndex + 1,
                            onClick: () => handleClick(value),
                            label: <span className={`!text-sm  ${value?.adMfaFlag === 0 ? "text-blue-600" : ""}`}>{value?.adMfaFlag === 0 ? "Enable MFA" : "Disable MFA"}</span>,
                            danger: !(value?.adMfaFlag === 0),
                            icon: value?.adMfaFlag === 0 ? <Shield className='icon text-blue-600' /> : <ShieldOff className='icon' />
                        }
                        if (actionItem?.isDelete) return {
                            key: actionIndex + 1,
                            onClick: () => handleClick(value),
                            label: <span className='!text-sm'>Delete</span>,
                            danger: true,
                            icon: <Trash className='icon' />
                        }
                        return null;
                    }) || []).filter(Boolean)
                    return (<>
                        <Dropdown placement='bottomRight' overlayClassName='table-action-menu' className='!p-2 !py-1 cursor-pointer !w-fit' menu={{ items }}>
                            <div>
                                <MoreOutlined />
                            </div>
                        </Dropdown>
                    </>)
                }
            };

            if (key === "status") {
                return {
                    ...item, renderCell: (val) => {
                        const statusVal = val?.row[key]?.toLowerCase();
                        let color = "default"
                        if (isEmpty(statusVal)) return emptyElement;
                        if (statusVal === "active" || statusVal === "registered") color = "green"
                        if (statusVal === "inactive" || statusVal === "revoked") color = "red"
                        if (statusVal === "pending") color = "orange"
                        return <Tag color={color} ><span className='text-xs !capitalize'>{statusVal}</span></Tag>
                    }
                }
            }

            if (key === "agentStatus") {
                return {
                    ...item, renderCell: (val) => {
                        const v = val?.row[key];
                        if (isEmpty(v)) return emptyElement;
                        let color = "default";
                        if (v === "Running") color = "green";
                        else if (v === "Inactive") color = "red";
                        return <Tag color={color}><span className='text-xs'>{v}</span></Tag>;
                    }
                }
            }

            if (item?.renderCell) {
                return { ...item }
            }

            return {
                ...item,
                renderCell: (val) =>
                    isEmpty(val?.row[key]) ?
                        emptyElement
                        :
                        <span className='text-[13px] tracking-[0.2px]'>{val?.row[key]}</span>
            }
        });
        setCustomColumns(customizeColumns);
    }, [tableStruture]);

    return (
        <DataGrid
            components={{
                NoRowsOverlay: CustomNoRowsOverlay,
                noResultsOverlay: CustomNoRowsOverlay,
            }}
            loading={isTableLoading}
            paginationMode="server"
            columns={customColumns}
            rows={data}
            // pagination
            page={pagination?.page}
            paginationModel={pagination}
            onPaginationModelChange={handleChangePagination}
            pageSizeOptions={[]}
            rowCount={totalCount}
        />
    )
}

export default DataGridTable;
